import { ExpiredOfflineObjectAsyncTimestampRemover } from '../abstract/expired-offline-object-async-timestamp-remover';
import { ImmoIPSubProjectChangesObject } from './immo-ip-sub-project-changes-object';

export class ExpiredImmoIPSubProjectChangesRemover extends ExpiredOfflineObjectAsyncTimestampRemover<
  number,
  ImmoIPSubProjectChangesObject
> {}
